<template>
  <button
      class="flex justify-center shadow-md transform hover:-translate-y-1 duration-200 hover:bg-gray-100 rounded"
      @click="addToCart">
        <shopping-bag-logo-white class="p-0" />
  </button>
</template>

<script>
import ShoppingBagLogoWhite from '@/components/graphics/ShoppingBagLogoWhite.vue';
import { addProductToCart } from '@/services/ProductService';

export default {
  props: {
    product: Object,
    quantity: Number,
    title: String,
  },

  components: {
    ShoppingBagLogoWhite,
  },

  methods: {
    addToCart() {
      if (!this.product) {
        this.createNotification('info', 'Funzione non ancora disponibile');
        return;
      }
      addProductToCart(this.product, this.quantity);
      this.createNotification('success', this.$t('product.addedToCart'));
    },
  },
};
</script>
